import { Link } from 'react-router-dom';

export default function CTASectionFr() {
  return (
    <section className="w-full py-20 px-6 md:px-16 bg-emerald-700 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10"
        style={{
          backgroundImage: "url('https://public.readdy.ai/ai/img_res/a940b3da1343f10c5027ac3f409da313.jpg')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <h2
          className="text-3xl md:text-5xl font-extrabold text-white mb-4"
          style={{ fontFamily: "'DM Serif Display', serif" }}
        >
          Prêt à optimiser votre approvisionnement?
        </h2>
        <p className="text-white/80 text-base md:text-lg mb-8 max-w-2xl mx-auto leading-relaxed">
          Laissez MAX-Sourcing mettre à profit un vaste réseau mondial de fournisseurs, fabricants, partenaires et ressources — en votre nom, sous complète confidentialité.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/fr/contact"
            className="bg-white text-emerald-800 font-bold px-8 py-3 rounded-md hover:bg-stone-100 transition-colors cursor-pointer whitespace-nowrap text-sm"
          >
            Contactez-nous aujourd&apos;hui
          </Link>
          <Link
            to="/fr/services"
            className="border-2 border-white/60 text-white font-bold px-8 py-3 rounded-md hover:border-white transition-colors cursor-pointer whitespace-nowrap text-sm"
          >
            Explorer nos services
          </Link>
        </div>
      </div>
    </section>
  );
}
